import { SpeciesAiSearchScreen } from '@screens/SpeciesSearch/SpeciesAiSearchScreen/SpeciesAiSearchScreen';

export default function ReportCreationSpeciesAiScreen(): React.ReactNode {
  return <SpeciesAiSearchScreen />;
}
